<div class="heading-div d-flex">
  <span class="heading-text"> Jayguru, {{ userName[0] }} </span>
  <div class="details-div d-flex">
    <div class="details d-flex flex-column">
      <span class="details-heading">Total</span>
      <div class="count-dtls d-flex justify-content-between">
        <!-- <span class="count">{{data.totalUpdated || 0}}</span> -->
        <span class="details-heading">{{ totalValue }}</span>
        <!-- <img
          src="../../../../../assets/images/dashboard-mob.svg"
          style="cursor: pointer"
        /> -->
      </div>
    </div>
    <div class="details d-flex flex-column">
      <span class="details-heading">Assigned</span>
      <div class="count-dtls d-flex justify-content-between">
        <!-- <span class="count">{{data.totalApproved || 0}}</span> -->
        <span class="details-heading">{{ assignedValue }}</span>
        <!-- <img
          src="../../../../../assets/images/dashboard-mob.svg"
          style="cursor: pointer"
        /> -->
      </div>
    </div>
    <div class="details d-flex flex-column">
      <span class="details-heading">Unasinged</span>
      <div class="count-dtls d-flex justify-content-between">
        <!-- <span class="count">{{data.totalDARejected + data.totalSURejected || 0}}</span> -->
        <span class="details-heading">{{ unasingedValue }}</span>
        <!-- <img
          src="../../../../../assets/images/dashboard-mob.svg"
          style="cursor: pointer"
        /> -->
      </div>
    </div>
  </div>
</div>
<div class="filter-row">
  <div class="search-filter">
    <input
      [(ngModel)]="userValue"
      (ngModelChange)="onSearch($event)"
      type="text"
      class="dp-input-control searchInput ng-untouched ng-pristine ng-valid"
      placeholder="Search by anything"
    />
    @if(reportType == 'user'){
    <div class="filter-div">
      <button
        class="buttonContent dp-primary-btn"
        (click)="onClickDialog()"
      ><div class="filter-btn-icon"></div>
    </button>
    </div>
    }
  </div>

  <div class="selectedButton">
    <button
      [class]="selectedReport === 'date' ? 'active' : ''"
      (click)="onClickDateWise('date')"
    >
      Datewise wise
    </button>
    <button
      [class]="selectedReport === 'user' ? 'active' : ''"
      (click)="onClickUserWise('user')"
    >
      User wise
    </button>
  </div>
</div>

@if(reportType == 'date'){
<table class="dp-table">
  <thead class="dp-table-header">
    <tr>
      @for (head of dateWiseTbleHeads; track $index) {
      <th>{{ head.label | titlecase }}</th>
      }
    </tr>
  </thead>

  <tbody class="dp-table-body">
    @if (apiValue.length) { @for (dateWiseData of apiValue; track $index) {
    <tr>
      @for (head of dateWiseTbleHeads ; track $index) {
      <td>
        {{
          head.key === "dt"
            ? (dateWiseData[head.key] | date)
            : dateWiseData[head.key]
        }}
      </td>
      }
    </tr>
    }}@else {
    <tr style="text-align: center">
      <td [colSpan]="TableHeadCount">
        <div class="noData">No record found</div>
      </td>
    </tr>
    }
  </tbody>
</table>
} @else if(reportType == 'user'){
<table class="dp-table">
  <thead class="dp-table-header">
    <tr>
      @for (head of userTableHeads; track $index) {
      <th>{{ head.label | titlecase }}</th>
      }
    </tr>
  </thead>

  <tbody class="dp-table-body">
    @if(apiValue.length){ @for (userWiseData of apiValue; track $index) {
    <tr>
      @for (head of userTableHeads; track $index) {
      <td>{{ userWiseData[head.key] }}</td>
      }
    </tr>
    }}@else {
    <tr style="text-align: center">
      <td [colSpan]="TableHeadCount">
        <div class="noData">No record found</div>
      </td>
    </tr>
    }
  </tbody>
</table>
}
